export default __webpack_public_path__ + "static/media/Keypad_Gray.96480e9d.svg";